import React from "react";

const modules = [

    {
        key: "marketplaceEnabled",
        title: "Marketplace",
        icon: "???",
        description: "Sell products & services on myFAVV Marketplace."
    },

    {
        key: "productsEnabled",
        title: "Products",
        icon: "??",
        description: "Physical & digital product management."
    },

    {
        key: "servicesEnabled",
        title: "Services",
        icon: "???",
        description: "Appointments, bookings & service listings."
    },

    {
        key: "inventoryEnabled",
        title: "Inventory",
        icon: "??",
        description: "Inventory & stock management."
    },

    {
        key: "ordersEnabled",
        title: "Orders",
        icon: "??",
        description: "Realtime order processing."
    },

    {
        key: "paymentsEnabled",
        title: "Payments",
        icon: "??",
        description: "Accept secure online payments."
    },

    {
        key: "shippingEnabled",
        title: "Shipping",
        icon: "??",
        description: "Packaging, shipment & delivery."
    },

    {
        key: "crmEnabled",
        title: "CRM",
        icon: "??",
        description: "Customer relationship management."
    },

    {
        key: "marketingEnabled",
        title: "Marketing",
        icon: "??",
        description: "Campaigns, promotions & analytics."
    },

    {
        key: "supportEnabled",
        title: "Customer Support",
        icon: "??",
        description: "Support tickets & live assistance."
    }

];

export default function BrandStep5({

    form,

    updateField

}) {

    return (

        <div>

            <h2
                style={{
                    marginBottom:8
                }}
            >
                Activate Your Business Suite
            </h2>

            <p
                style={{
                    color:"#666",
                    marginBottom:30,
                    lineHeight:1.6
                }}
            >
                Choose which business tools you would like to enable.
                You can always enable or disable them later from
                Brand Settings.
            </p>

            <div
                style={{
                    display:"grid",
                    gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",
                    gap:18,
                    marginBottom:35
                }}
            >

                {modules.map(module=>(

                    <div

                        key={module.key}

                        style={{
                            border:"1px solid #E5E7EB",
                            borderRadius:14,
                            padding:20,
                            background:"#fff",
                            boxShadow:"0 4px 12px rgba(0,0,0,.04)"
                        }}

                    >

                        <div
                            style={{
                                display:"flex",
                                justifyContent:"space-between",
                                alignItems:"center",
                                marginBottom:12
                            }}
                        >

                            <div
                                style={{
                                    fontSize:28
                                }}
                            >
                                {module.icon}
                            </div>

                            <input

                                type="checkbox"

                                checked={form[module.key] ?? false}

                                onChange={(e)=>

                                    updateField(
                                        module.key,
                                        e.target.checked
                                    )

                                }

                            />

                        </div>

                        <h3
                            style={{
                                marginBottom:8
                            }}
                        >
                            {module.title}
                        </h3>

                        <p
                            style={{
                                color:"#777",
                                fontSize:14,
                                lineHeight:1.5
                            }}
                        >
                            {module.description}
                        </p>

                    </div>

                ))}

            </div>

            <div

                style={{
                    marginTop:20,
                    background:"#F8FAFC",
                    border:"1px solid #E2E8F0",
                    borderRadius:16,
                    padding:24
                }}

            >

                <h3
                    style={{
                        marginTop:0,
                        marginBottom:20
                    }}
                >
                    Review Your Brand
                </h3>

                <div
                    style={{
                        display:"grid",
                        gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",
                        gap:20
                    }}
                >

                    <div>

                        <strong>Brand Name</strong>

                        <div>{form.brandName || "-"}</div>

                    </div>

                    <div>

                        <strong>Business Type</strong>

                        <div>{form.businessType || "-"}</div>

                    </div>

                    <div>

                        <strong>Category</strong>

                        <div>{form.category || "-"}</div>

                    </div>

                    <div>

                        <strong>Owner</strong>

                        <div>{form.ownerName || "-"}</div>

                    </div>

                    <div>

                        <strong>Email</strong>

                        <div>{form.email || "-"}</div>

                    </div>

                    <div>

                        <strong>Phone</strong>

                        <div>{form.phone || "-"}</div>

                    </div>

                    <div>

                        <strong>Website</strong>

                        <div>{form.website || "-"}</div>

                    </div>

                    <div>

                        <strong>Country</strong>

                        <div>{form.country || "-"}</div>

                    </div>

                    <div>

                        <strong>Currency</strong>

                        <div>{form.currency}</div>

                    </div>

                    <div>

                        <strong>Language</strong>

                        <div>{form.language}</div>

                    </div>

                    <div>

                        <strong>Timezone</strong>

                        <div>{form.timezone}</div>

                    </div>

                </div>

                <hr
                    style={{
                        margin:"30px 0"
                    }}
                />

                <div>

                    <h4
                        style={{
                            marginBottom:16
                        }}
                    >
                        Enabled Modules
                    </h4>

                    <div
                        style={{
                            display:"flex",
                            flexWrap:"wrap",
                            gap:12
                        }}
                    >

                        {modules
                            .filter(module => form[module.key])
                            .map(module => (

                                <div
                                    key={module.key}
                                    style={{
                                        background:"#10B981",
                                        color:"#fff",
                                        padding:"8px 14px",
                                        borderRadius:999,
                                        fontSize:13,
                                        fontWeight:600
                                    }}
                                >
                                    {module.icon} {module.title}
                                </div>

                            ))}

                        {!modules.some(module => form[module.key]) && (

                            <div
                                style={{
                                    color:"#888"
                                }}
                            >
                                No modules selected.
                            </div>

                        )}

                    </div>

                </div>

                <div
                    style={{
                        marginTop:35,
                        padding:24,
                        borderRadius:16,
                        background:"linear-gradient(135deg,#4F46E5,#2563EB)",
                        color:"#fff"
                    }}
                >

                    <h3
                        style={{
                            marginTop:0,
                            marginBottom:12
                        }}
                    >
                        🚀 You're Ready to Launch
                    </h3>

                    <p
                        style={{
                            lineHeight:1.8,
                            marginBottom:0
                        }}
                    >
                        Your business is now ready to become a part of the
                        myFAVV Business Ecosystem.

                        After clicking <strong>Finish</strong>, your Brand
                        Dashboard will be created automatically.

                        From there you'll be able to manage products,
                        services, inventory, bookings, payments,
                        customers, marketing, support and every other
                        business operation from one place.
                    </p>

                </div>

            </div>

        </div>

    );

}